import { render, staticRenderFns } from "./ApplicationsCosts.vue?vue&type=template&id=14145512&scoped=true"
import script from "./ApplicationsCosts.vue?vue&type=script&lang=js"
export * from "./ApplicationsCosts.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsCosts.vue?vue&type=style&index=0&id=14145512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14145512",
  null
  
)

export default component.exports